export const CHARTS_ROUTE = '/matching/dashboard/charts'

// Пороги зон заполненности пула: ниже WARN — зелёная, от WARN — жёлтая, от CRIT — красная.
export const POOL_FILL_WARN = 60
export const POOL_FILL_CRIT = 80

// Зоны — цвета порогов, а не цвета серий депозитов/выплат: красный здесь и есть тревога.
// Непрозрачные: зоны рисуются друг поверх друга и обязаны перекрывать заднюю.
export const POOL_FILL_ZONE_COLORS = {
  light: { green: '#B5DDB5', yellow: '#F4E3A6', red: '#ECB4B4', line: '#3F4254' },
  dark: { green: '#2F5A3A', yellow: '#6B5A24', red: '#6E3434', line: '#CDCDDE' },
} as const
